import Breakpoint from '../helpers/breakpoint';

const SiteSearch               = (() => {
	const DOM                  = {};
	const transitionBreakpoint = "md";

	const cacheDOM           = () => {
		DOM.siteSearchToggle = document.querySelector( '.js-site-search-toggle' );
		DOM.siteSearch       = document.querySelector( '.js-site-search' );
	}

	const toggleSiteSearch = () => {
		DOM.siteSearch.classList.toggle( "site-search--open" );
		DOM.siteSearchToggle.classList.toggle( "site-search-toggle--open" );
	};

	const buttonClicked = (e) => {
		e.preventDefault();
		toggleSiteSearch();
	}

	const eventListeners = () => {
		if ( ! DOM.siteSearchToggle || ! DOM.siteSearch) {
			return;
		}
		let addSiteSearchEventListeners = () => {
			DOM.siteSearchToggle.addEventListener( "click", buttonClicked );
		}

		if (Breakpoint.isBreakpointUp( transitionBreakpoint )) {
			addSiteSearchEventListeners();
		}

		window.addEventListener(
			'resize',
			function () {
				if (Breakpoint.isBreakpointUp( transitionBreakpoint )) {
					addSiteSearchEventListeners();
				}
			},
			false
		);
	};

	const init = () => {
		cacheDOM();
		eventListeners();
	};

	return {
		init,
	};
})();

export default SiteSearch;
